import {
  createEffect,
  createMemo,
  createSignal,
  onMount,
  onCleanup,
  For,
  Show,
  Switch,
  Match,
} from "https://cdn.jsdelivr.net/npm/solid-js@1.8.22/+esm";
import { render } from "https://cdn.jsdelivr.net/npm/solid-js@1.8.22/web/+esm";
import html from "https://cdn.jsdelivr.net/npm/solid-js@1.8.22/html/+esm";

(function (meta) {
  /* Script Setup START */
  const url = new URL(meta.url);
  const script = document.querySelector(
    `script[src*="${url.pathname + url.search}"]`,
  );
  if (!script)
    return console.warn(
      `Unable to find the script tag with the provided URL. Skipping script execution.`,
    );
  const sectionId = script.getAttribute("data-section-id");
  if (!sectionId)
    return console.warn(
      `No section ID provided (data-section-id). Skipping script execution.`,
    );
  const section = document.getElementById(`shopify-section-${sectionId}`);
  if (!section)
    return console.warn(
      `Unable to find the section with the provided ID. Skipping script execution.`,
    );
  const entryTarget = section.querySelector(
    `${script.getAttribute("data-entry-target")}`,
  );
  if (!entryTarget)
    return console.warn(
      `Unable to find the entry target with the provided selector. Skipping script execution.`,
    );
  const quizData = createMemo(() => {
    try {
      const script = section.querySelector('script[type="application/json"]');
      if (!script) return null;
      return JSON.parse(script.textContent);
    } catch (error) {
      console.warn(error);
      return null;
    }
  });
  if (!quizData())
    return console.warn(
      `Unable to parse the quiz data. Skipping script execution.`,
    );
  console.log("Loaded quiz data:", quizData());

  function navigateToQuiz() {
    window.location.href = quizData()?.system.url.startsWith("https://")
      ? quizData()?.system.url
      : `https://${window.location.origin}${quizData()?.system.url}`;
  }

  const klaviyoEventMap = {
    started: "Quiz Started",
    next: "Quiz Next",
    back: "Quiz Back",
    answer_selected: "Quiz Answer Selected",
    submitted_with_email: "Quiz Submitted w/Email",
    submitted: "Quiz Submitted",
    viewed_results: "Quiz Results Viewed",
  };

  function publishEvent(eventName, data) {
    klaviyoTrack(klaviyoEventMap[eventName], data);
    sendDomEvent(eventName, data);
    publishShopifyEvent(eventName, data);
  }

  function klaviyoTrack(eventName, properties) {
    if (typeof window.klaviyo === "undefined") return;
    klaviyo.push(["track", eventName, properties]);
  }

  function sendDomEvent(eventName, data) {
    const event = new CustomEvent(`quiz:${eventName}`, { detail: data });
    window.dispatchEvent(event);
  }

  function publishShopifyEvent(eventName, data) {
    if (typeof window.Shopify.analytics === "undefined") return;
    window.Shopify.analytics.publish(`quiz:${eventName}`, data);
  }

  function klaviyoTrack(eventName, properties) {
    if (typeof window.klaviyo === "undefined") return;
    klaviyo.push(["track", eventName, properties]);
  }

  function sendDomEvent(eventName, data) {
    const event = new CustomEvent(`quiz:${eventName}`, { detail: data });
    window.dispatchEvent(event);
  }

  function publishShopifyEvent(eventName, data) {
    if (typeof window.Shopify.analytics === "undefined") return;
    window.Shopify.analytics.publish(`quiz:${eventName}`, data);
  }

  const localStorageKey = () => `quiz-results:${quizData()?.system.handle}`;
  const answers = createMemo(() => {
    const url = new URL(window.location.href);
    if (url.searchParams.has("answers"))
      return JSON.parse(url.searchParams.getAll("answers"));
    if (localStorage.getItem(localStorageKey()))
      return JSON.parse(localStorage.getItem(localStorageKey()));
    return [];
  });

  const results = () => {
    const a = answers();
    return a.reduce((question, answerIndex, index) => {
      const answer = question.answers[answerIndex];
      if (index === a.length - 1) return answer?.results || null;
      if (!Reflect.has(answer, "question")) return null;
      return Reflect.get(answer, "question");
    }, quizData().question);
  };

  createEffect(() => {
    if (results()) return;
    return navigateToQuiz();
  });

  function RoutineIcons(props) {
    return html`
      <${Show} when=${() => props.times.length > 0}>
        <span class="routineIcons">
          <${For} each=${() => props.times}>
            ${(time) => html`
              <${Switch}>
                <${Match} when=${() => time === "am"}>
                  <span innerHTML=${() => quizData()?.icons.svgAM} />
                <//>
                <${Match} when=${() => time === "pm"}>
                  <span innerHTML=${() => quizData()?.icons.svgPM} />
                <//>
              <//>
            `}
          <//>
        </span>
      <//>
    `;
  }

  function transformImageSrc(src, { width, height, crop } = {}) {
    const url = new URL(src.startsWith("https://") ? src : `https:${src}`);
    const srcNoParams = src.split("?")[0];
    if (width) url.searchParams.set("width", width);
    if (height) url.searchParams.set("height", height);
    if (crop) url.searchParams.set("crop", crop);
    return `${srcNoParams}${url.search}`;
  }

  function ShopifyImage(props) {
    const src = () =>
      transformImageSrc(props.image?.src, {
        width: props.width,
        height: props.height,
      });
    return html`
      <img
        src=${src}
        alt=${() => props.image?.alt}
        loading="lazy"
        class=${() => props.class || ""}
        width=${() => props.width}
        height=${() => props.height}
        style=${() => props.style}
      />
    `;
  }

  function ProductGridItemImages(props) {
    return html`
      <${Switch}>
        <${Match} when=${() => props.images.length === 1}>
          <${Show} when=${() => props.images[0]}>
            <${ShopifyImage} image=${() => props.images[0]} width=${580} />
          <//>
        <//>
        <${Match} when=${() => props.images.length > 1}>
          <${For} each=${() => (props.images || []).slice(0, 2)}>
            ${(image, idx) => html`
              <${Show} when=${() => image}>
                <${ShopifyImage}
                  image=${() => image}
                  width=${580}
                  class=${() => (idx() === 0 ? "first-img" : "second-img")}
                />
              <//>
            `}
          <//>
        <//>
      <//>
    `;
  }

  function ProductGridItemReviews(props) {
    return html`
      <div class="prodReviewsInline">
        <div
          data-bv-show="inline_rating"
          data-bv-product-id=${() => props.product?.id}
          data-bv-redirect-url=${() => props.product?.url}
          data-bv-seo="false"
        />
      </div>
    `;
  }

  function ReadMore(props) {
    const [isOpen, setIsOpen] = createSignal(false);

    function handleClick(e) {
      e.preventDefault();
      setIsOpen((isOpen) => !isOpen);
    }

    return html`
      <div
        class=${() => props.class}
        style=${() =>
          isOpen()
            ? ""
            : "-webkit-line-clamp: 3; display: -webkit-box; -webkit-box-orient: vertical; overflow: hidden;"}
      >
        ${() => props.children}
        <a
          href="javascript:void(0);"
          class="readmore"
          style=${() =>
            isOpen()
              ? "display: inline; position: relative; padding-left:0px;"
              : "display: inline;position: absolute;"}
          onClick=${(e) => handleClick(e)}
        >
          ${() => (isOpen() ? "Show Less" : "Read More")}
        </a>
      </div>
    `;
  }

  function ProductPrice(props) {
    const priceNumber = createMemo(() => props.variant.price);
    const compareAtPriceNumber = createMemo(() =>
      props.variant.compare_at_price ? props.variant.compare_at_price : 0,
    );
    const formattedPrice = createMemo(() => Shopify.formatMoney(priceNumber()));
    const formattedCompareAtPrice = createMemo(() =>
      Shopify.formatMoney(compareAtPriceNumber()),
    );

    return html`
      <span class="priceRange ps-1">
        <${Switch}>
          <${Match} when=${() => priceNumber() < compareAtPriceNumber()}>
            <s class="priceRange__actual">${formattedCompareAtPrice}</s>${" "}
            <span class="priceRange__sale ms-0">${formattedPrice}</span>
          <//>
          <${Match} when=${() => priceNumber() >= compareAtPriceNumber()}>
            ${formattedPrice}
          <//>
        <//>
      </span>
    `;
  }

  function FormattedPrice(props) {
    const price = () => props.price;
    const formattedPrice = createMemo(() => Shopify.formatMoney(price()));
    return formattedPrice;
  }

  function ProductGridForm(props) {
    const firstVariant = () => props.product?.variants[0];
    function ProductSoldOutButton(props) {
      return html`
        <div class="soldOut">
          <button
            class=${() =>
              `button btn-blue AddToCart d-block product-size-label btn custom-notify-me-btn product_${props?.product?.id} mb-0`}
            data-swaction="addToWatchlist"
            data-product-id=${() => props.product?.id}
            data-variant-id=${() => firstVariant()?.id}
            data-url=${() => props.product?.url}
            style="display: block; margin-bottom: 20px;"
            name="id"
            data-sku=${() => firstVariant()?.sku}
            value=${() => firstVariant()?.id}
            data-button-price=${() => firstVariant().price}
            type="button"
          >
            Join Waitlist
          </button>
        </div>
      `;
    }
    return html`
      <${Switch}>
        <${Match} when=${() => props.product.variants.length === 1}>
          <${Show}
            when=${() => firstVariant()?.available}
            fallback=${html`<${ProductSoldOutButton}
              product=${() => props.product}
            />`}
          >
            <form
              action="/cart/add"
              method="post"
              data-productid=${() => props.product?.id}
              enctype="multipart/form-data"
              class="AddToCartForm prodGridItemForm"
            >
              <input
                name="id"
                type="hidden"
                value=${() => firstVariant()?.id}
              />
              <div class="cta-quantity">
                <label
                  for="Quantity"
                  class="quantity-selector"
                  style="visibility: hidden;"
                  >Quantity</label
                >
                <input
                  type="number"
                  name="quantity"
                  value="1"
                  min="1"
                  class="quantity-selector visually-hidden"
                  tabindex="0"
                />
                <div class="add-to-cart">
                  <div
                    class="product-form-submit-wrap"
                    itemscope=""
                    itemprop="offers"
                    itemtype="http://schema.org/offers"
                    onclick="ga('send', 'event', 'Button', 'Click', 'Add to Cart');"
                  >
                    <button
                      type="submit"
                      name="add"
                      class=${() =>
                        props.btnClass ? props.btnClass : "AddToCart"}
                      style=${() =>
                        props.btnStyle
                          ? props.btnStyle
                          : "display: block;width:max-content;"}
                      tabindex="0"
                    >
                      <span class="AddToCartText" itemprop="price">
                        ${() =>
                          quizData()?.content?.products?.product?.add_to_cart}
                        <${ProductPrice} variant=${firstVariant} />
                      </span>
                    </button>
                  </div>
                </div>
              </div>
            </form>
          <//>
        <//>
        <${Match} when=${() => props.product.variants.length > 1}>
          <div class="add-to-cart">
            <div
              class="product-form-submit-wrap"
              itemscope=""
              itemprop="offers"
              itemtype="http://schema.org/offers"
              onclick="ga('send', 'event', 'Button', 'Click', 'Add to Cart');"
            >
              <a
                href=${() => props.product?.url}
                tabindex="0"
                class="button btn-blue"
                style="display: block;width:max-content;"
              >
                <span class="AddToCartText" itemprop="price">
                  Select Size
                  <span class="priceRange ps-1">
                    <${FormattedPrice}
                      price=${() => props.product?.price_min}
                    />${" - "}
                    <${FormattedPrice}
                      price=${() => props.product?.price_max}
                    />
                  </span>
                </span>
              </a>
            </div>
          </div>
        <//>
      <//>
    `;
  }

  function ProductGridItem(props) {
    const routine = () => props.product?.metafields?.routine;
    const accentColor = () =>
      props.product?.metafields?.accentuate?.accent_color;
    const productMetafields = () => props.product?.metafields?.product;

    return html`
      <div class="prodGridItem">
        <${Show} when=${() => routine()?.name}>
          <div class="routineIndicator">
            <h4 style="font-weight: bold;">
              ${() => routine()?.name}
              <${RoutineIcons} times=${() => routine()?.time || []} />
            </h4>
          </div>
        <//>
        <div class="hoverCTA">
          <a
            href=${() => props.product?.url}
            class="grid__image"
            style=${() =>
              accentColor() ? `--border-color: ${accentColor()};` : ""}
          >
            <${ProductGridItemImages}
              images=${() => props.product?.images || []}
            />
            <${Show} when=${() => productMetafields()?.flag}>
              <div class="prodFlag">${() => productMetafields()?.flag}</div>
            <//>
          </a>
          <div class="prodGridItemText">
            <${ProductGridItemReviews} product=${() => props.product} />
            <a href=${() => props.product?.url} tabindex="0">
              <h4 class="prodTitle">${() => props.product?.title}</h4>
            </a>
            <${Show} when=${() => productMetafields()?.excerpt}>
              <p class="p2 prodExcerpt">
                ${() => productMetafields()?.excerpt}
              </p>
            <//>
          </div>
          <${ProductGridForm} product=${() => props.product} />
        </div>
      </div>
    `;
  }

  function PdpStarRating(props) {
    return html`
      <div
        class="yotpo-widget-instance"
        data-yotpo-instance-id="445007"
        data-yotpo-product-id=${() => props.product.id}
      ></div>
    `;
  }

  function SystemItem(props) {
    const productMetafields = () => props.system?.metafields?.product;
    const quizMetafields = () => props.system?.metafields?.quiz;
    const routine = () => props.product?.metafields?.routine;
    return html`
      <div class="bestMatchProduct m-0 container">
        <div class="row justify-content-center">
          <div class="col-lg-3 col-md-5">
            <div class="bestMatchImg">
              <${Show} when=${() => productMetafields()?.flag}>
                <div class="prodFlag">${() => productMetafields()?.flag}</div>
              <//>
              <${Show} when=${() => routine()?.time?.length > 0}>
                <div
                  class="routineIndicator position-absolute"
                  style="top:10px;left:10px;padding-inline:0px;"
                >
                  <h4 style="font-weight: bold;">
                    <${RoutineIcons}
                      times=${() => routine()?.time || ["am", "pm"]}
                    />
                  </h4>
                </div>
              <//>
              <div class="bestMatchImgContainer">
                <${Show} when=${() => props.system?.featured_image}>
                  <${ShopifyImage}
                    image=${() => props.system?.featured_image}
                    width=${400}
                    height=${400}
                  />
                <//>
              </div>
            </div>
          </div>
          <div class="col-lg-5 col-md-7 d-md-flex align-items-center">
            <div class="bestMatchText">
              <div class="mb-2">
                <h3 class="mb-0">${() => props.system?.title}</h3>
                <${PdpStarRating} product=${() => props.system} />
              </div>
              <${Show}
                when=${() =>
                  quizMetafields()?.excerpt && !props.usesOtherExcerpt}
              >
                <div class="p" innerHTML=${() => quizMetafields()?.excerpt} />
              <//>
              <${Show}
                when=${() =>
                  quizMetafields()?.description && props.usesOtherExcerpt}
              >
                <div innerHTML=${() => quizMetafields()?.description} />
              <//>
              <${ProductGridForm}
                btnClass="button btn-blue AddToCart"
                product=${() => props.system}
              />
            </div>
          </div>
        </div>
      </div>
    `;
  }

  function NewRoutineTabs() {
    return html`
      <ul
        class="nav nav-pills justify-content-center custom-tabs mx-auto"
        id="myTab"
        role="tablist"
      >
        <li class="nav-item" role="presentation">
          <button
            class="nav-link active"
            id="basic-tab"
            data-bs-toggle="tab"
            data-bs-target="#basicRoutinePanel"
            type="button"
            role="tab"
          >
            Basic
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button
            class="nav-link"
            id="advanced-tab"
            data-bs-toggle="tab"
            data-bs-target="#advancedRoutinePanel"
            type="button"
            role="tab"
          >
            Advanced
          </button>
        </li>
      </ul>
    `;
  }

  function BasicRoutinePanel(props) {
    const firstSystem = () => results()?.systems?.[0];
    const config = {
      mode: "free-snap",
      loop: false,
      slides: {
        perView: 1,
        perScroll: 1,
        spacing: 30,
      },
    };
    let tabPanel = null,
      slider = null;

    onMount(() => {
      const controller = new AbortController();
      if (!tabPanel) return;
      const tab = document.querySelector(
        `[data-bs-target="#${tabPanel.getAttribute("id")}"]`,
      );

      tab.addEventListener(
        "shown.bs.tab",
        (event) => {
          if (!slider) return;
          slider.slider().update();
        },
        { signal: controller.signal },
      );

      return onCleanup(() => controller.abort("Component unmounted"));
    });

    return html`
      <div
        id="basicRoutinePanel"
        class="tab-pane fade show active"
        role="tabpanel"
        ref=${(el) => (tabPanel = el)}
      >
        <div id="newBasicRoutine" class="results-card">
          <h2 class="text-center mt-4">Your routine</h2>
          <keen-slider
            class="keen-slider"
            config=${config}
            style="overflow:visible!important;"
            ref=${(el) => (slider = el)}
          >
            <div class="keen-slider__slide">
              <${CurrentRoutineItem} product=${firstSystem} />
            </div>
          </keen-slider>
        </div>
      </div>
    `;
    return html`
      <div
        id="basicRoutinePanel"
        class="tab-pane fade show active"
        role="tabpanel"
      >
        <div id="newBasicRoutine" class="results-card">
          <h2 class="text-center mt-4">Your routine</h2>
          <${SystemItem} system=${firstSystem} />
        </div>
      </div>
    `;
  }

  function AdvancedRoutinePanel(props) {
    // const firstSystem = () => results()?.products?.[0];
    // const restProducts = () => results()?.products?.slice(1);
    let tabPanel = null,
      slider = null;
    const config = {
      mode: "free-snap",
      loop: false,
      slides: {
        perView: 1,
        perScroll: 1,
        spacing: 30,
      },
    };

    onMount(() => {
      const controller = new AbortController();
      if (!tabPanel) return;
      const tab = document.querySelector(
        `[data-bs-target="#${tabPanel.getAttribute("id")}"]`,
      );

      tab.addEventListener(
        "shown.bs.tab",
        (event) => {
          if (!slider) return;
          slider.slider().update();
        },
        { signal: controller.signal },
      );

      return onCleanup(() => controller.abort("Component unmounted"));
    });

    return html`
      <div
        id="advancedRoutinePanel"
        class="tab-pane fade"
        role="tabpanel"
        ref=${(el) => (tabPanel = el)}
      >
        <div id="newAdvancedRoutine" class="results-card">
          <h2 class="text-center mt-4">Your routine</h2>
          <keen-slider
            class="keen-slider"
            config=${config}
            style="overflow:visible!important;"
            ref=${(el) => (slider = el)}
          >
            <${For} each=${() => results()?.products}>
              ${(product) => html`
                <div class="keen-slider__slide">
                  <${CurrentRoutineItem} product=${product} />
                </div>
              `}
            <//>
          </keen-slider>
        </div>
      </div>
    `;
    // return html`
    //   <div id="advancedRoutinePanel" class="tab-pane fade" role="tabpanel">
    //     <div id="newAdvancedRoutine" class="results-card">
    //       <h2 class="text-center mt-4">Your routine</h2>
    //       <${SystemItem} system=${firstSystem} />
    //       <div style="margin-top:80px;">
    //         <${Show} when=${() => restProducts()?.length > 0}>
    //           <h2 class="text-center mt-4">Add to your current routine</h2>
    //           <${For} each=${() => results()?.products.slice(1)}>
    //             ${(product) => html`
    //               <div class="py-4">
    //                 <${SystemItem}
    //                   system=${() => product}
    //                   usesOtherExcerpt=${true}
    //                 />
    //               </div>
    //             `}
    //           <//>
    //         <//>
    //       </div>
    //     </div>
    //   </div>
    // `;
  }

  function NewRoutine(props) {
    const hasBasicRoutine = () => results()?.systems?.length > 0;
    const hasAdvancedRoutine = () => results()?.products?.length > 0;
    return html`
      <${Show} when=${hasBasicRoutine}>
        <${Show} when=${hasAdvancedRoutine}>
          <${NewRoutineTabs} />
        <//>
        <div class="tab-content" id="myTabContent">
          <${BasicRoutinePanel} />
          <${Show} when=${hasAdvancedRoutine}>
            <${AdvancedRoutinePanel} />
          <//>
        </div>
      <//>
    `;
  }

  function CurrentRoutineItem(props) {
    const productExcerpt = () => props.product?.metafields?.product?.excerpt;
    const routine = () => props.product?.metafields?.routine;
    const quizProductDescription = () =>
      props.product?.metafields?.quiz?.description ||
      props.product?.description;

    return html`
      <div class="container">
        <div class="row gx-lg-5">
          <div class="col-md-5" style="max-height:400px;">
            <${Show} when=${() => props.product?.featured_image}>
              <${ShopifyImage}
                image=${() => props.product?.featured_image}
                width=${600}
                style="max-width:100%;object-fit:contain;height:100%;max-height:100%;border: 1px solid #e0e0e0;border-radius: 18px;"
              />
            <//>
          </div>
          <div class="col-md-7 py-2">
            <hgroup class="mb-3">
              <div class="routineIndicator" style="padding-inline: 0px;">
                <h3
                  class="h1 m-0 d-flex align-items-center justify-content-between"
                >
                  <a href=${() => props.product?.url}>
                    ${() => props.product?.title}
                  </a>
                  <${RoutineIcons} times=${() => routine()?.time || []} />
                </h3>
              </div>
              <${Show} when=${productExcerpt}>
                <p class="m-0">${productExcerpt}</p>
              <//>
            </hgroup>
            <div class="mb-3">
              <${PdpStarRating} product=${() => props.product} />
            </div>
            <${Show} when=${quizProductDescription}>
              <div
                class="productDescription"
                innerHTML=${quizProductDescription}
              ></div>
            <//>
            <div class="mt-5">
              <${ProductGridForm}
                btnClass="button btn-blue AddToCart"
                product=${() => props.product}
              />
            </div>
            <div class="keen-nav my-4">
              <nav>
                <keen-navigation-arrows
                  target="#addToYourRoutine"
                  class="d-flex"
                  style="gap: .75rem;"
                >
                  <template
                    prev-arrow
                    innerHTML=${() => quizData().icons.svgAccordionArrow}
                  />
                  <template
                    next-arrow
                    innerHTML=${() => quizData().icons.svgAccordionArrow}
                  />
                </keen-navigation-arrows>
              </nav>
            </div>
          </div>
        </div>
      </div>
    `;
  }

  function AddToCurrentRoutine(props) {
    const config = {
      mode: "free-snap",
      loop: false,
      slides: {
        perView: 1,
        perScroll: 1,
        spacing: 30,
      },
    };

    return html`
      <${Show}
        when=${() => !results()?.systems?.length && results()?.products?.length}
      >
        <div id="addToYourRoutine" class="results-card">
          <keen-slider
            class="keen-slider"
            config=${config}
            style="overflow:visible!important;"
          >
            <${For} each=${() => results()?.products}>
              ${(product) => html`
                <div class="keen-slider__slide">
                  <${CurrentRoutineItem} product=${product} />
                </div>
              `}
            <//>
          </keen-slider>
          <div class="container">
            <div class="row gx-lg-5">
              <div class="col-12">
                <keen-scrollbar
                  is-hidden="true"
                  target="#addToYourRoutine"
                ></keen-scrollbar>
              </div>
            </div>
          </div>
        </div>
      <//>
    `;
  }

  function BestMatch() {
    const hasIndividualResults = () =>
      !results()?.systems?.length && results()?.products?.length;
    return html`
      <div id="bestMatch">
        <div class="container">
          <div class="bestMatchHeader">
            <${Show} when=${hasIndividualResults}>
              <h1>Add these products to your current routine</h1>
            <//>
            <${Show} when=${() => !hasIndividualResults()}>
              <h1>${() => results()?.header}</h1>
            <//>
            <p>${() => results()?.copy}</p>
          </div>
          <div class="bestMatchInner">
            <div class="tab-pane fade active show" id="pills-body">
              <${AddToCurrentRoutine} />
              <${NewRoutine} />
              <${Addons} />
            </div>
          </div>
        </div>
      </div>
    `;
  }

  function Addons() {
    const config = {
      loop: false,
      mode: "free-snap",
      slides: {
        perView: 2,
        perScroll: 2,
        spacing: 16,
      },
      breakpoints: {
        "(min-width: 992px)": {
          loop: false,
          mode: "free-snap",
          slides: {
            perView: 2.3,
            perScroll: 2,
            spacing: 16,
          },
        },
        "(min-width: 1260px)": {
          loop: false,
          mode: "free-snap",
          slides: {
            perView: 3.2,
            perScroll: 3,
            spacing: 16,
          },
        },
        "(min-width: 1330px)": {
          loop: false,
          mode: "free-snap",
          slides: {
            perView: 4,
            perScroll: 2,
            spacing: 16,
          },
        },
      },
    };

    return html`
      <${Show} when=${() => quizData().settings.addons.length}>
        <div
          id="yourRoutine"
          class="productsContainer mt-5"
          style="overflow:hidden;"
        >
          <div class="quizResults-nav">
            <div>
              <h2 class="m-0">Add-ons</h2>
            </div>
            <nav>
              <keen-navigation-arrows
                target="#yourRoutine"
                class="d-flex"
                style="gap: .75rem;"
              >
                <template
                  prev-arrow
                  innerHTML=${() => quizData().icons.svgAccordionArrow}
                />
                <template
                  next-arrow
                  innerHTML=${() => quizData().icons.svgAccordionArrow}
                />
              </keen-navigation-arrows>
            </nav>
          </div>
          <keen-slider
            class="keen-slider"
            config=${config}
            style="overflow:visible!important;"
          >
            <${For} each=${() => quizData().settings.addons}>
              ${(product) => html`
                <div class="keen-slider__slide">
                  <${ProductGridItem} product=${product} />
                </div>
              `}
            <//>
          </keen-slider>
          <keen-scrollbar
            is-hidden="true"
            target="#yourRoutine"
          ></keen-scrollbar>
        </div>
      <//>
    `;
  }

  function App() {
    onMount(() => {
      publishEvent("viewed_results", {
        id: quizData().system.id,
        title: quizData().system.title,
        path: quizData().url,
        results: [...results().products, ...results().systems].map(
          (product) => ({
            id: product.id,
            available: product.available,
            price: Shopify.formatMoney(product.price),
            compare_at_price: Shopify.formatMoney(product.compare_at_price),
            title: product.title,
            url: product.url,
          }),
        ),
      });
    });
    return html`
      <${BestMatch} />
      <div id="retake" class="mt-5">
        <div class="container">
          <p class="mb-0">
            <a href=${() => quizData()?.system?.url} class="button btn-outline"
              >Retake the Quiz</a
            >
          </p>
        </div>
      </div>
    `;
  }

  render(App, entryTarget);
})(import.meta);
